import { render, staticRenderFns } from "./Table-products.vue?vue&type=template&id=f55683d0&scoped=true&"
import script from "./Table-products.vue?vue&type=script&lang=js&"
export * from "./Table-products.vue?vue&type=script&lang=js&"
import style0 from "./Table-products.vue?vue&type=style&index=0&id=f55683d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55683d0",
  null
  
)

export default component.exports